export default __webpack_public_path__ + "static/media/homeLogo1.a8c2b46d.png";